import classNames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import {
  IconButton,
  BlackDeleteIcon as blackDeleteIcon,
  BlackExpandHorizontalIcon as blackExpandHorizontalIcon,
  BlackUndoIcon as blackUndoIcon,
} from '@/shared/ui';
import { TYPE_BEAT_ENUM } from '@/shared/config';
import { defaultControlModalValue } from '@/entities/report';
import { EventThumbnailConfig } from '@/entities/ecg';
import PaginationContainer from './paginationContainer';
import useButtonTypes from './useButtonTypes';

/**
 * Renders the artifact-area toolbar with change-duration, delete and reset actions plus thumbnail and pagination controls. Opens the change-duration modal only when it is not already open, deletes by pushing the DELETED beat type through handleChangeStripType, shows the reset control only when isShowResetButton, and takes every disabled state from the hook.
 *
 * @returns The rendered toolbar row for the artifact-areas strip list.
 */
const ButtonTypes = () => {
  const {
    isLoadingStrip,
    isDisableChangeDuration,
    getControlModal,
    setControlModal,
    handleChangeStripType,
    isDisableChangingButton,
    isShowResetButton,
    isDisableCommonButton,
    onClickResetChange,
  } = useButtonTypes();

  return (
    <div
      id="button-types"
      className={classNames('beat-type-strip-content-top-container', '--min-width-strip-event')}
    >
      <div className="toolbar">
        <IconButton
          id="btnChangeEventDurationBeatHr"
          isOutline
          iconComponent={<img src={blackExpandHorizontalIcon} alt="Expand horizontal icon" />}
          disabled={isDisableChangeDuration}
          onClick={() => {
            if (!getControlModal().isShowChangeDurationButtonType) {
              setControlModal({
                ...defaultControlModalValue,
                isShowChangeDurationButtonType: true,
              });
            }
          }}
        />
        <UncontrolledTooltip
          className="custom-tooltip"
          target="btnChangeEventDurationBeatHr"
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          hideArrow
        >
          <div className="beat-tooltip">
            Change event duration
            <span className="shortkey">C</span>
          </div>
        </UncontrolledTooltip>
        <IconButton
          id="btnDeleteBeatHr"
          isOutline
          iconComponent={<img src={blackDeleteIcon} alt="Delete icon" />}
          onClick={() => handleChangeStripType(TYPE_BEAT_ENUM.DELETED)}
          // isDisableWhenSaving includes an Array#find() result (IEvent | IBeat | undefined), not a boolean - pre-existing.
          disabled={isDisableChangingButton as any}
        />
        <UncontrolledTooltip
          className="custom-tooltip"
          target="btnDeleteBeatHr"
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          hideArrow
        >
          <div className="beat-tooltip">
            Delete event
            <span className="shortkey">D</span>
          </div>
        </UncontrolledTooltip>
        {!!isShowResetButton && (
          <>
            <div className="btn-type-vertical-line" />
            <IconButton
              id="btnResetBeatHr"
              isOutline
              iconComponent={<img src={blackUndoIcon} alt="Noise icon" />}
              disabled={isDisableCommonButton as any}
              onClick={onClickResetChange}
            />
            <UncontrolledTooltip
              className="custom-tooltip"
              target="btnResetBeatHr"
              placement="bottom"
              delay={{ show: 0, hide: 0 }}
              hideArrow
            >
              <div className="beat-tooltip">Reset changes</div>
            </UncontrolledTooltip>
          </>
        )}
      </div>
      <EventThumbnailConfig isArtifact isDisabled={isLoadingStrip} />
      <PaginationContainer isDisabled={isLoadingStrip} />
    </div>
  );
};

export default ButtonTypes;
